import { Head, usePage } from '@inertiajs/react';

import {
  type LedgerItem,
  MetaDot,
  RecordBackLink,
  RecordBody,
  RecordLedger,
  RecordMasthead,
  RecordSection,
  RecordSheet,
  RecordText,
} from '@/components/admin/detail/RecordSheet';
import { StatusActionBar } from '@/components/admin/detail/StatusActionBar';
import { StatusStamp } from '@/components/admin/detail/StatusStamp';
import type { Message } from '@/components/admin/messages/MessagesTable';

const SUBJECT_LABELS: Record<string, string> = {
  geral: 'Geral',
  servicos: 'Serviços',
  documentacao: 'Documentação',
  reclamacao: 'Reclamação',
  outro: 'Outro',
};

interface MessageDetailProps {
  message: Message;
  [key: string]: unknown;
}

export default function MessageDetail() {
  const { message } = usePage<MessageDetailProps>().props;
  const subjectLabel = SUBJECT_LABELS[message.subject] ?? message.subject;

  const ledger: LedgerItem[] = [
    { label: 'Submetida', value: new Date(message.submittedAt).toLocaleString('pt-PT') },
  ];
  if (message.handledBy) {
    ledger.push({
      label: 'Tratada por',
      value: message.handledAt
        ? `${message.handledBy} · ${new Date(message.handledAt).toLocaleDateString('pt-PT')}`
        : message.handledBy,
    });
  }

  return (
    <>
      <Head title={`Mensagem de ${message.name} — Administração`} />
      <RecordBackLink href="/messages" label="Voltar a Mensagens" />

      <RecordSheet>
        <RecordMasthead
          typeTag="Mensagem de contacto"
          title={message.name}
          topRight={<StatusStamp status={message.status} />}
          meta={
            <>
              <span className="border-line bg-background text-on-surface-light rounded-full border px-2 py-0.5 text-[11px]">
                {subjectLabel}
              </span>
              <span className="text-primary font-bold tracking-wide">{message.referenceCode}</span>
              <MetaDot />
              <span>{message.email}</span>
              <MetaDot />
              <span>{new Date(message.submittedAt).toLocaleString('pt-PT')}</span>
            </>
          }
        />
        <RecordBody>
          <RecordSection label="Mensagem">
            <RecordText>{message.message}</RecordText>
          </RecordSection>
        </RecordBody>
        <RecordLedger items={ledger} />
        <StatusActionBar
          basePath="/messages"
          id={message.id}
          status={message.status}
          resolveLabel="Marcar como resolvida"
        />
      </RecordSheet>
    </>
  );
}
